import { STRINGS } from '../config/i18n';
import { TODAY } from '../config/constants';

// ── Helpers ───────────────────────────────────────────────────────
export function daysBetween(a,b){ return Math.ceil((b-a)/(1000*60*60*24)); }
export function parseDate(s){ return s ? new Date(s) : null; }
export function fmtDate(s){
  if(!s) return "—";
  return String(s).slice(0,10); // YYYY-MM-DD
}
export function getPaymentSlots(start,end){
  const slots=[]; const e=new Date(end); let cur=new Date(start);
  while(cur<e){
    const next=new Date(cur); next.setMonth(next.getMonth()+1);
    slots.push({ key:`${cur.getFullYear()}-${String(cur.getMonth()+1).padStart(2,"0")}`, dueDate:cur.toISOString().slice(0,10) });
    cur=next;
  }
  return slots;
}

export const TENANT_STATUS_COLORS = {
  available:{ color:"#38bdf8", bg:"rgba(56,189,248,0.12)",  dot:"#38bdf8" },
  expired:  { color:"#6b7280", bg:"rgba(107,114,128,0.13)", dot:"#6b7280" },
  overdue:  { color:"#ef4444", bg:"rgba(239,68,68,0.12)",   dot:"#ef4444" },
  due_today:{ color:"#f59e0b", bg:"rgba(245,158,11,0.14)",  dot:"#f59e0b" },
  due_soon: { color:"#f97316", bg:"rgba(249,115,22,0.12)",  dot:"#f97316" },
  paid:     { color:"#22c55e", bg:"rgba(34,197,94,0.12)",   dot:"#22c55e" },
  future:   { color:"#a78bfa", bg:"rgba(167,139,250,0.12)", dot:"#a78bfa" },
};
export function getTenantStatusCfg(status, lang){
  const s = STRINGS[lang||"ar"];
  const label = s.status[status] || status;
  return { ...TENANT_STATUS_COLORS[status], label };
}
// Keep backward compat for places that reference TENANT_STATUS_CFG directly
export const TENANT_STATUS_CFG = Object.fromEntries(
  Object.entries(TENANT_STATUS_COLORS).map(([k,v])=>[k,{...v,label:STRINGS.ar.status[k]||k}])
);

export function getTenantStatus(t){
  if(t.available) return "available";
  if(!t.contractEnd) return "available";
  const end=parseDate(t.contractEnd);
  if(end<=TODAY) return "expired";
  const slots=getPaymentSlots(t.contractStart,t.contractEnd);
  for(const slot of slots){
    const p=t.payments[slot.key];
    if(!p||!p.paid){
      const d=daysBetween(TODAY,parseDate(slot.dueDate));
      if(d<0) return "overdue"; if(d===0) return "due_today"; if(d<=7) return "due_soon"; return "future";
    }
  }
  return "paid";
}

export function getCurrentSlot(t){
  if(!t.contractStart||!t.contractEnd) return null;
  const slots=getPaymentSlots(t.contractStart,t.contractEnd);
  for(const s of slots){ const p=t.payments[s.key]; if(!p||!p.paid) return s; }
  return slots[slots.length-1]||null;
}

// ── Shared helpers ────────────────────────────────────────────────




// ══════════════════════════════════════════════════════════════════
// TAB 4 — Partnerships & Owners
// ══════════════════════════════════════════════════════════════════
export function calcSplit(gross, ownershipCfg, splits){
  // gross → management fee (FindRE) → net split by shares
  const fee    = Math.round(gross * (ownershipCfg.managementFeePercent||15) / 100);
  const net    = gross - fee;
  const result = { gross, fee, net, shares:{} };
  (splits||[]).forEach(s=>{
    const amt = Math.round(net * s.sharePercent / 100);
    const key = s.type==="me" ? "me" : s.partnerId;
    result.shares[key] = (result.shares[key]||0) + amt;
  });
  // FindRE total = fee + own equity share
  result.findreTotal = fee + (result.shares["me"]||0);
  return result;
}

export function buildDefaultUnits(tenants) {
  const seen = {};
  tenants.forEach(t => {
    const key = `${t.unit}-${t.district}`;
    if (!seen[key]) seen[key] = { id: key, unitNumber: t.unit, district: t.district, imageUrl: '', mapsUrl: '', customName: '', notes: '' };
  });
  return Object.values(seen);
}

export function generatePaymentDates(nextDate, freq) {
  const dates = [];
  let cur = new Date(nextDate);
  const monthsPerPayment = freq === 1 ? 12 : freq === 2 ? 6 : 3;
  for (let i = 0; i < freq; i++) {
    dates.push(cur.toISOString().slice(0, 10));
    cur = new Date(cur);
    cur.setMonth(cur.getMonth() + monthsPerPayment);
  }
  return dates;
}
